import { Dashboard } from "views/Dashboard";
import React from "react";


export const Statistics = () => <Dashboard />;